import vue from 'vue'
import { structure, nonClearableFields } from './structure'
import { cloneDeep } from 'HELPERS'

export default {
  state: {
    ...cloneDeep(structure)
  },
  getters: {
    getLogisticModelingActiveLayers: state => state.activeLayers,
    getLogisticModelingGeomType: state => id => state.layerTypes[id]
  },
  mutations: {
    LOGISTIC_MODELING_RESET(state) {
      for (const field in structure) {
        if (nonClearableFields.includes(field)) continue
        state[field] = cloneDeep(structure[field])
      }
    },
    LOGISTIC_MODELING_SET(state, [field, value]) {
      if (field.includes('.')) {
        const [parent, child] = field.split('.')
        vue.set(state[parent], `${child}`, value)
      } else {
        state[field] = value
      }
    },
    LOGISTIC_MODELING_ASSIGN(state, { field, key, value }) {
      state[field] = Object.assign({ ...state[field] }, { [key]: value })
    },
    LOGISTIC_MODELING_PUSH(state, [field, value]) {
      state[field].push(value)
    },
    LOGISTIC_MODELING_SPLICE(state, [field, value]) {
      const index = state[field].indexOf(value)

      if (index >= 0) state[field].splice(index, 1)
    }
  }
}
